import AbstractChart from './abstract-chart.js';


export default class ColumnChart extends AbstractChart 
{

	constructor(params) 
	{
		super(params);

		this.params.type = 'column';
		
		this.params.chart_options.bar = {
			groupWidth: '95%',
			pieSliceText: 'label'
		};
	}
	
	createVisualization() 
	{
		return new google.visualization.ColumnChart(document.getElementById(this.params.id));
	}

}